/** @jsxImportSource @emotion/react */
import { forwardRef, type Ref, memo } from 'react';
import type { To } from '@trinity/chat-components/containers/Chat/RoutingProvider';
import { cx } from '@trinity/chat-components/utils';
import type { LinkProps } from './Link';
import { Link } from './Link';

type Props = {
  css?: CSSOverrides;
  classes?: {
    link?: string;
    notlink?: string;
  };
  children: React.ReactNode;
  to?: To;
} & Omit<LinkProps, 'to'>;

type RefProps = HTMLAnchorElement | HTMLSpanElement;

export const MaybeLink = memo(forwardRef<RefProps, Props>(({ css = {}, classes = {}, ...props }: Props, ref: Ref<RefProps>) => {
  return props.to
    ? <Link
      css={css}
      ref={ref as Ref<HTMLAnchorElement>}
      {...props}
      to={props.to}
      className={cx(classes.link, props.className)} />
    : (
      <span
        css={css}
        ref={ref as Ref<HTMLSpanElement>}
        {...props}
        className={cx(classes.notlink, props.className)}>
        {props.children}
      </span>
    );
}));

MaybeLink.displayName = 'MaybeLink';